export default "__VITE_ASSET__CFYVEngO__"